import React from 'react'
import {Link as NavLink, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import PropTypes from 'prop-types'
import CategorySmallImage from './category-small-image'
import Video from '../../hero/partials/video'
import CategoryTitle from './category-title'
import usePdTagManager from '../../../../../hooks/use-pd-tag-manager'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
const Card = (props) => {
    const {
        linkUrl,
        isTextOverlay = 'bottom',
        cardsLength,
        key,
        typeId,
        index,

        // Image Settings
        desktopVideo,
        desktopVideoThumbnail,
        mobileVideo,
        mobileVideoThumbnail,
        videoAlt,
        videoDisableAutoPlay,
        videoEnableSound,

        // Video Settings
        desktopImage,
        imageAlt,
        mobileImage,

        // Title Basic Settings
        title,
        titleAlign,
        titleColor,
        titleFontFamily,
        titleTag,
        titleBackground,

        // Title Font Settings
        titleSizeLargeDesktop,
        titleSizeMobile,
        titleSizeSmallDesktop,
        titleSizeTablet
    } = props
    const pdTagManager = usePdTagManager()
    const appOrigin = useAppOrigin()
    const shouldDisplayVideo = desktopVideo || mobileVideo
    const isExternalDomain = linkUrl?.indexOf('http') !== -1
    const wrapperProps =
        linkUrl && !shouldDisplayVideo
            ? isExternalDomain
                ? {as: NavLink, href: linkUrl}
                : {as: RouteLink, to: linkUrl, display: 'block'}
            : {}
    const linkProps = linkUrl ? {display: 'block'} : {}

    return (
        <Box
            {...wrapperProps}
            {...linkProps}
            key={key}
            className="category-tile"
            display="grid"
            height="auto"
            sx={{
                video: {
                    aspectRatio: '1/1 !important'
                },
                _hover: {
                    textDecoration: 'unset'
                }
            }}
            onClick={() => {
                if (shouldDisplayVideo) {
                    return
                }
                pdTagManager.selectComponent({
                    componentId: typeId,
                    componentName: name,
                    titleName: title,
                    titlePosition: index,
                    linkUrl: linkUrl?.indexOf('http') !== -1 ? linkUrl : `${appOrigin}${linkUrl}`,
                    imageUrl: desktopImage || mobileImage
                })
            }}
        >
            {shouldDisplayVideo ? (
                <Video
                    desktopVideo={desktopVideo}
                    mobileVideo={mobileVideo || desktopVideo}
                    desktopVideoThumbnail={desktopVideoThumbnail}
                    mobileVideoThumbnail={mobileVideoThumbnail}
                    videoDisableAutoPlay={videoDisableAutoPlay}
                    videoEnableSound={videoEnableSound}
                    videoAlt={videoAlt}
                />
            ) : (
                <CategorySmallImage
                    desktopImage={desktopImage}
                    mobileImage={mobileImage}
                    imageAlt={imageAlt}
                    cardsLength={cardsLength}
                />
            )}
            <CategoryTitle
                title={title}
                index={index}
                typeId={typeId}
                videoUrl={mobileVideo || desktopVideo}
                isTextOverlay={isTextOverlay}
                titleColor={titleColor}
                titleTag={titleTag}
                titleSizeMobile={titleSizeMobile}
                titleSizeTablet={titleSizeTablet}
                titleSizeLargeDesktop={titleSizeLargeDesktop}
                titleFontFamily={titleFontFamily}
                titleBackground={titleBackground}
                titleSizeSmallDesktop={titleSizeSmallDesktop}
                titleAlign={titleAlign}
                linkUrl={linkUrl}
                shouldDisplayVideo={shouldDisplayVideo}
            />
        </Box>
    )
}

Card.propTypes = {
    // General Settings
    linkUrl: PropTypes.any,
    isTextOverlay: PropTypes.any,
    cardsLength: PropTypes.any,
    key: PropTypes.any,
    titleBackground: PropTypes.any,
    typeId: PropTypes.string,
    index: PropTypes.number,

    // Video props
    desktopVideo: PropTypes.string,
    desktopVideoThumbnail: PropTypes.string,
    mobileVideo: PropTypes.string,
    mobileVideoThumbnail: PropTypes.string,
    videoAlt: PropTypes.string,
    videoDisableAutoPlay: PropTypes.bool,
    videoEnableSound: PropTypes.bool,

    // Image props
    desktopImage: PropTypes.string,
    mobileImage: PropTypes.string,
    imageAlt: PropTypes.string,

    // Title props
    title: PropTypes.string,
    titleAlign: PropTypes.string,
    titleColor: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleTag: PropTypes.string,

    // Title sizes
    titleSizeLargeDesktop: PropTypes.string,
    titleSizeSmallDesktop: PropTypes.string,
    titleSizeTablet: PropTypes.string,
    titleSizeMobile: PropTypes.string
}

export default Card
